import React from 'react';
export function Footer() {
  return <footer className="py-8 px-4 sm:px-6 bg-brand-navy-dark text-center text-white/50 text-[10px] sm:text-xs border-t border-white/10" data-id="element-69">
      <p className="leading-relaxed max-w-2xl mx-auto font-medium mb-5" data-id="element-70">
        © 2026 RUNNING COACH READY™ — All Rights Reserved.
        <br data-id="element-71" />
        <br data-id="element-72" />
        The content of this page is for educational purposes only and does not
        replace professional coaching or medical advice. Always follow
        appropriate safety guidelines and consult a healthcare professional
        before starting any training program.
      </p>
      <div className="flex justify-center gap-4 sm:gap-6 font-bold tracking-widest uppercase" data-id="element-73">
        <a href="#" className="hover:text-brand-teal transition-colors" data-id="element-74">
          Terms & Conditions
        </a>
        <span className="text-white/20" data-id="element-75">·</span>
        <a href="#" className="hover:text-brand-teal transition-colors" data-id="element-76">
          Privacy Policy
        </a>
        <span className="text-white/20" data-id="element-77">·</span>
        <a href="#" className="hover:text-brand-teal transition-colors" data-id="element-78">
          Contact
        </a>
      </div>
    </footer>;
}